import { axiosWithAuth } from './../axiosWithAuth';
import { API_BASE_URL } from '../env';
import { EP_CREATE_ORDER, EP_DELETE_ORDER, EP_GET_ALL_ORDERS, EP_SEARCH_ORDER, EP_UPDATE_ORDER } from './api';

export const getAllordersService = async () =>{
    let server= API_BASE_URL+EP_GET_ALL_ORDERS.path
    return await axiosWithAuth(server,{
        method : EP_GET_ALL_ORDERS.method
    })
}

export const createOrderService = async (requestBody?: any) =>{
    let server= API_BASE_URL+EP_CREATE_ORDER.path
    let body = requestBody ? requestBody : EP_CREATE_ORDER.requestBody;
    return await axiosWithAuth(server,{
        method : EP_CREATE_ORDER.method,
        data: {...body}
    })
}

export const deleteOrderService = async (requestBody?: any) =>{
    let server= API_BASE_URL+EP_DELETE_ORDER.path
    let body = requestBody ? requestBody : EP_DELETE_ORDER.requestBody;
    return await axiosWithAuth(server,{
        method : EP_DELETE_ORDER.method,
        data: {...body}
    })
}

export const updateOrderService = async (requestBody?: any) =>{
    let server= API_BASE_URL+EP_UPDATE_ORDER.path
    let body = requestBody ? requestBody : EP_UPDATE_ORDER.requestBody;
    return await axiosWithAuth(server,{
        method : EP_UPDATE_ORDER.method,
        data: {...body}
    })
}

export const searchOrderService = async (params?: any) =>{
    let server= API_BASE_URL+EP_SEARCH_ORDER.path
    let queryParams = params ? params : EP_SEARCH_ORDER.params;
    return await axiosWithAuth(server,{
        method : EP_SEARCH_ORDER.method,
        params: queryParams
    })
}